import React from 'react';
import {Platform, View} from 'react-native';
import {WebView} from 'react-native-webview';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useSelector} from 'react-redux';
import {useNavigation} from '@react-navigation/native';

import Screen from '../../shared/components/screen';
import {profileTokenSelector} from '../../redux/selectors/profile';
import {Screens} from '../../shared/routing';
import {images} from '../../assets/icons';
import {Link} from '../../shared/components/link';
import {useStyles} from '../../shared/hooks/styles';
import {Text} from '../../shared/components/text';

export const WebScreen = (props: {route?: {params: {url: string}}}) => {
  const nav = useNavigation();
  const token = useSelector(profileTokenSelector());
  const isOldAndroid = Platform.OS === 'android' && typeof Platform.Version === 'number' && Platform.Version < 29;
  const styles = useStyles(({theme, addShadow}) => {
    return {
      header: {
        height: 54,
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: theme.color.primaryNonGreyBackground,
        ...addShadow({
          radius: 2,
          height: 1,
          color: theme.color.primaryBlackColor,
          opacity: 0.24,
        }),
      },
      headerText: {
        ...theme.fonts.h6,
        width: 268,
        textAlign: 'center',
      },
      link: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 54,
        width: 54,
        color: theme.color.textColor,
      },
    };
  });
  return (
    <Screen>
      <SafeAreaView>
        {!token ? (
          <View style={styles.header}>
            <Link testID={`aggreement-link-id`} style={styles.link} navigate={nav.navigate} screen={Screens.Login}>
              <images.Left height={25} width={25} color={styles.link.color} />
            </Link>
            <Text style={styles.headerText}>Соглашение о персональных данных</Text>
          </View>
        ) : null}
        <WebView
          scalesPageToFit={true}
          mixedContentMode='compatibility'
          source={{uri: props.route?.params.url ?? ''}}
          startInLoadingState={true}
          androidLayerType={isOldAndroid ? 'software' : undefined}
          renderLoading={() => <View />}
          renderError={() => <View />}
        />
      </SafeAreaView>
    </Screen>
  );
};
